module.exports = __webpack_public_path__ + "static/img/2.a7f7f0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/2.jpg
// module id = SWci
// module chunks = 1